export const formatForSelect = (dataToFormat, moods = false) => {
  let selectData = [];
  dataToFormat.sort(({ id: a }, { id: b }) => a - b);
  dataToFormat.forEach((value) => {
    selectData.push({
      key: value.id,
      text: value.name,
      value: moods
        ? value.id
        : {
            id: value.id,
            name: value.name,
          },
    });
  });
  return selectData;
};

export const formatMoodForSubmit = (moodId, moodOptions) => {
  const mood = moodOptions.filter((obj) => {
    return obj.key === moodId;
  })[0];

  return {
    id: mood.key,
    name: mood.text,
  };
};
